"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _TokenList_instances, _TokenList_tokens, _TokenList_validate;
Object.defineProperty(exports, "__esModule", { value: true });
const InvalidCharacterError_1 = require("../errors/InvalidCharacterError");
/**
 * Represents a set of space-separated tokens. It is indexed
 * beginning with 0 as with JavaScript Array objects. TokenList
 * is always case-sensitive.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMTokenList
 */
class TokenList {
    constructor() {
        _TokenList_instances.add(this);
        _TokenList_tokens.set(this, []);
    }
    static parse(value) {
        if (!value) {
            return [];
        }
        const set = new Set();
        const list = String(value).split(/\s+/);
        return list.filter((value) => {
            if (Boolean(value) && !set.has(value)) {
                set.add(value);
                return true;
            }
            return false;
        });
    }
    static from(...tokens) {
        const list = new TokenList();
        for (const token of tokens) {
            list.add(...this.parse(token));
        }
        return list;
    }
    static join(tokens) {
        return this.from(...tokens).value;
    }
    static isToken(token) {
        return !token || !/\s+/.test(token);
    }
    /** Returns the number of tokens. */
    get length() {
        return __classPrivateFieldGet(this, _TokenList_tokens, "f").length;
    }
    /**
     * Returns the associated set as string.
     *
     * Can be set, to change the associated attribute.
     */
    get value() {
        return __classPrivateFieldGet(this, _TokenList_tokens, "f").join(' ');
    }
    /**
     * Returns the associated set as string.
     *
     * Can be set, to change the associated attribute.
     */
    set value(value) {
        __classPrivateFieldSet(this, _TokenList_tokens, TokenList.parse(value), "f");
    }
    item(index) {
        var _a;
        return (_a = __classPrivateFieldGet(this, _TokenList_tokens, "f")[index]) !== null && _a !== void 0 ? _a : null;
    }
    contains(token) {
        return __classPrivateFieldGet(this, _TokenList_tokens, "f").includes(token);
    }
    add(...tokens) {
        if (tokens.length === 0) {
            return;
        }
        const set = new Set(__classPrivateFieldGet(this, _TokenList_tokens, "f"));
        for (const token of tokens) {
            __classPrivateFieldGet(this, _TokenList_instances, "m", _TokenList_validate).call(this, 'add', token);
            if (!set.has(token)) {
                __classPrivateFieldGet(this, _TokenList_tokens, "f").push(token);
            }
        }
    }
    remove(...tokens) {
        if (tokens.length === 0) {
            return;
        }
        const set = new Set();
        for (const token of tokens) {
            __classPrivateFieldGet(this, _TokenList_instances, "m", _TokenList_validate).call(this, 'remove', token);
            set.add(token);
        }
        __classPrivateFieldSet(this, _TokenList_tokens, __classPrivateFieldGet(this, _TokenList_tokens, "f").filter((currentToken) => !set.has(currentToken)), "f");
    }
    replace(oldToken, newToken) {
        __classPrivateFieldGet(this, _TokenList_instances, "m", _TokenList_validate).call(this, 'replace', oldToken);
        __classPrivateFieldGet(this, _TokenList_instances, "m", _TokenList_validate).call(this, 'replace', newToken);
        if (!__classPrivateFieldGet(this, _TokenList_tokens, "f").includes(oldToken)) {
            return false;
        }
        if (__classPrivateFieldGet(this, _TokenList_tokens, "f").includes(newToken)) {
            __classPrivateFieldSet(this, _TokenList_tokens, __classPrivateFieldGet(this, _TokenList_tokens, "f").filter((token) => token !== oldToken), "f");
        }
        else {
            __classPrivateFieldSet(this, _TokenList_tokens, __classPrivateFieldGet(this, _TokenList_tokens, "f").map((token) => token === oldToken ? newToken : token), "f");
        }
        return true;
    }
    supports() {
        throw new TypeError(`Failed to execute 'supports' on 'TokenList': TokenList has no supported tokens.`);
    }
    toggle(token, force) {
        __classPrivateFieldGet(this, _TokenList_instances, "m", _TokenList_validate).call(this, 'toggle', token);
        switch (force) {
            case true:
                this.add(token);
                return true;
            case false:
                this.remove(token);
                return false;
            default:
                if (!__classPrivateFieldGet(this, _TokenList_tokens, "f").includes(token)) {
                    this.add(token);
                    return true;
                }
                else {
                    this.remove(token);
                    return false;
                }
        }
    }
    entries() {
        return __classPrivateFieldGet(this, _TokenList_tokens, "f").entries();
    }
    forEach(callbackfn, thisArg) {
        __classPrivateFieldGet(this, _TokenList_tokens, "f").forEach((value, key) => callbackfn.call(thisArg !== null && thisArg !== void 0 ? thisArg : this, value, key, this), thisArg);
    }
    keys() {
        return __classPrivateFieldGet(this, _TokenList_tokens, "f").keys();
    }
    values() {
        return __classPrivateFieldGet(this, _TokenList_tokens, "f").values();
    }
    toString() {
        return this.value;
    }
    [(_TokenList_tokens = new WeakMap(), _TokenList_instances = new WeakSet(), _TokenList_validate = function _TokenList_validate(method, token) {
        if (!token) {
            throw new SyntaxError(`Failed to execute '${method}' on 'TokenList': The token provided must not be empty.`);
        }
        if (!TokenList.isToken(token)) {
            throw new InvalidCharacterError_1.InvalidCharacterError(`Failed to execute '${token}' on 'TokenList': The token provided ('${token}') contains HTML space characters, which are not valid in tokens.`);
        }
        return true;
    }, Symbol.iterator)]() {
        return this.values();
    }
}
exports.default = TokenList;
